export type CompanyReferralMilestoneReward = {
  label: string;
  description: string;
  asterisk?: number;
};

export type CompanyReferralMilestone = {
  threshold: number;
  description: string;
  rewards: CompanyReferralMilestoneReward[];
};

const MILESTONE_20K: CompanyReferralMilestone = {
  threshold: 20,
  description: "Get |$20,000| managed for free",
  rewards: [
    {
      label: "$20k of direct indexing managed free",
      description: "Your first $20k of direct indexing managed for free",
    },
  ],
};

const MILESTONE_50K: CompanyReferralMilestone = {
  threshold: 50,
  description: "Get |$50,000| managed for free",
  rewards: [
    {
      label: "$50k of direct indexing managed free",
      description: "Your first $50k of direct indexing managed for free",
    },
  ],
};

const MILESTONE_75K: CompanyReferralMilestone = {
  threshold: 100,
  description: "Get |$75,000| managed for free",
  rewards: [
    {
      label: "$75k of direct indexing managed free",
      description: "Your first $75k of direct indexing managed for free",
    },
    {
      label: "No wire fees",
      description: "No outgoing wire fees. Incoming wire fees are always free.",
    },
    {
      label: "No transfer fees",
      description:
        "We reimburse incoming stock transfer fees your brokerage may charge (terms apply). Plus, we’ll waive outgoing stock transfer fees.",
    },
  ],
};

const MILESTONE_100K: CompanyReferralMilestone = {
  threshold: 200,
  description: "Get |$100,000| managed for free",
  rewards: [
    {
      label: "$100k of direct indexing managed free",
      description: "Your first $100k of direct indexing managed for free",
    },
    {
      label: "Borrow at 5.13% vs 5.33%",
      description: "Borrow up to 70% of your portfolio at 5.13%",
      asterisk: 4,
    },
    {
      label: "No wire fees",
      description: "No outgoing wire fees. Incoming wire fees are always free.",
    },
    {
      label: "No transfer fees",
      description:
        "We reimburse incoming stock transfer fees your brokerage may charge (terms apply). Plus, we’ll waive outgoing stock transfer fees.",
    },
  ],
};

export const COMPANY_REFERRAL_MILESTONES = [
  MILESTONE_20K,
  MILESTONE_50K,
  MILESTONE_75K,
  MILESTONE_100K,
];
